document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!form.matches('.burnouts-email-inquiry')) return;
  event.preventDefault();
  const lines = [];
  for (const [key, value] of new FormData(form)) {
    if (!String(value).trim()) continue;
    const label = key.replace(/^contact\[/, '').replace(/\]$/, '');
    lines.push(label + ': ' + value);
  }
  const status = form.querySelector('.burnouts-email-status');
  if (status) status.hidden = false;
  const subject = 'Tattoo consultation request';
  window.location.href = 'mailto:burnoutsgaragetattoo@gmail.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(lines.join('\n\n'));
});
